import '../../IdfIcon.vue_vue_type_style_index_0_lang.css';
import { defineComponent, computed, openBlock, createBlock, resolveDynamicComponent, normalizeClass } from 'vue';
import * as index from './navigation/index.mjs';
import * as index$1 from './function/index.mjs';
import * as index$2 from './state/index.mjs';
import * as index$3 from './theme/index.mjs';
import * as index$4 from './logo/index.mjs';
import * as index$5 from './decorative/index.mjs';

const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    components: {
      ...index,
      ...index$1,
      ...index$2,
      ...index$3,
      ...index$4,
      ...index$5
    }
  },
  __name: "IdfIcon",
  props: {
    kind: {},
    alt: {},
    ariaHidden: { type: Boolean, default: false },
    hasCssColorVars: { type: Boolean, default: false },
    size: { default: "m" }
  },
  setup(__props) {
    const props = __props;
    const kindIcon = computed(() => `idf-icon-${props.kind}`);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(kindIcon.value), {
        "aria-label": __props.ariaHidden ? void 0 : __props.alt,
        "aria-hidden": __props.ariaHidden,
        class: normalizeClass(["idf-icon", [
          `idf-icon--${__props.size}`,
          {
            "idf-icon--with-color-vars": __props.hasCssColorVars
          }
        ]])
      }, null, 8, ["aria-label", "aria-hidden", "class"]);
    };
  }
});

export { _sfc_main as default };
